import React from 'react'
import { Outlet } from 'react-router-dom'
import { Stack, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import EmptyScreen from 'packages/ui/EmptyScreen'
import MainContent, { TableContent } from 'components-shared'

import { useSites, useHasSitesOnProduction } from 'store'

import Topbar from './Topbar'
import Table from './Table'
import PreConfiguredNetworks from './PreConfiguredNetworks'
import useList from './use-event-ssids'

const EventSsids = () => {
  const { t } = useTranslation()
  const hasSitesOnProduction = useHasSitesOnProduction()
  const [{ selected }] = useSites()
  const { error } = useList()

  return (
    <Stack flex={1}>
      {
        selected.length !== 1 || !hasSitesOnProduction
          ? <EmptyScreen icon="calendar-star" iconSize="80px">
              {!hasSitesOnProduction ? t('ui_elements.service_soon') : t('event_ssids.no_site_selected')}
            </EmptyScreen>
          : error
            ? <EmptyScreen icon="calendar-star" iconSize="80px">
                {t(`api_errors.${error}`)}
              </EmptyScreen>
            : (
              <>
                <Topbar />
                <MainContent>
                  <Stack sx={{ flex: 1, overflow: 'hidden', gap: 2 }}>
                    <Box 
                      sx={{ 
                        height: '50%',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                      }}
                    >
                      <TableContent>
                        <Table />
                      </TableContent>
                    </Box>
                    <Box sx={{ pb: 3 }}>
                      <PreConfiguredNetworks />
                    </Box>
                  </Stack>
                  <Outlet />
                </MainContent>
              </>
            )
      }
    </Stack>
  )
}

export default EventSsids